import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doREQUEST_ERROR, doREQUEST_COMPLETE, doWORKSPACE_ROLE_LIST_SET} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH = 'REQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH'
export const doREQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH = createDoRequestAction(
  REQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH,
)

export const requestIdentityWorkspaceCollaboratorListFetchActionCreators = {
  doREQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH,
}

export function* requestIdentityWorkspaceCollaboratorListFetch({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestIdentityWorkspaceCollaboratorListFetch')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        page: v.number().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {page} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/identity-workspace-collaborator-list-fetch`,
    accessToken,
    data: {
      page,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/identity-workspace-collaborator-list-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doWORKSPACE_ROLE_LIST_SET(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* identityWorkspaceCollaboratorListFetchSaga() {
  yield takeEvery(REQUEST_IDENTITY_WORKSPACE_COLLABORATOR_LIST_FETCH, requestIdentityWorkspaceCollaboratorListFetch)
}
